import { Component } from "@angular/core";
import { GroupDescriptor } from "@progress/kendo-data-query";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { NameValue } from "projects/sepidz-web-framework/src/lib/models/name-value";
import { Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { MisSetupService } from "projects/sepidz-web-framework/src/lib/services/missetup.service";
import { takeUntil } from "rxjs/operators";
import { AccCloseProfitandLossAccountsDetail } from "../../models/acc-close-profitand-loss-accounts-detail.model";
import { VoucherInfo } from "../../models/voucherInfo.model";

@Component({
  selector: "ngx-control-contrary-nature-account-list",
  templateUrl: "./control-contrary-nature-account-list.component.html",
  styleUrls: ["./control-contrary-nature-account-list.component.scss"],
})
export class ControlContraryNatureAccountListComponent extends BaseListComponent {
  loadingIndicator: boolean;
  inputEditorform: any;
  filterInfo: NameValue[] = [];
  groups: GroupDescriptor[] = [{ field: "SubLedgerTitle" }];
  editingName: { name: string };
  voucherInfo: VoucherInfo = <VoucherInfo>{};

  constructor(private missetup: MisSetupService) {
    super();
  }
  get detailLedgerLevel(): number {
    return this.missetup.getnumber("ACC", "DLLEVEL");
  }
  ngOnInit() {
    this.apiName = "AccCloseProfitandLossAccountsHeader";
    this.areaName = "Accounting";
    this.label = this.translate("ClientApp.BackOffice.ACC.AccCloseProfitandLossAccountsHeader.ControlContraryNatureAccount");
    super.ngOnInit();
    this.setColumns();
    if (this.accountService.authService.currentFiscalYear) {
      this.voucherInfo.FiscalYearId = this.accountService.authService.currentFiscalYear?.Id;
      this.voucherInfo.BranchId = this.accountService.authService.currentBranchId;
      this.voucherInfo.VoucherDate = new Date();
      this.getVoucher();
    } else
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x) {
          this.voucherInfo.FiscalYearId = x.Id;
          this.voucherInfo.BranchId = this.accountService.authService.currentBranchId;
          this.voucherInfo.VoucherDate = new Date();
          this.getVoucher();
        }
      });
  }
  getVoucher() {
    this.httpCommonService
      .create("AccCloseProfitandLossAccountsHeader/GetControlContraryNatureAccountDetail", this.voucherInfo)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          if (data != undefined) {
            this.dataList = data as AccCloseProfitandLossAccountsDetail[];
          }
        },
        (error) => {
          this.sts.showDialog(`${this.label}: ${Utilities.getHttpResponseMessage(error)}`, "خطا در بارگذاری اطلاعات");
        }
      );
  }

  setColumns() {
    this.httpCommonService
      .getControlsList(this.apiName.split("/")[0])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        if (data) {
          this.columns = (data as form_control[]).find((x) => x.name === "AccCloseProfitandLossAccountsDetails").DetailControlModels[
            "AccCloseProfitandLossAccountsDetails"
          ];
          this.columns = this.columns.sort((a, b) => a.order - b.order);
          this.columns.forEach((x) => {
            if (x.name.includes("DetailLedger1")) {
              if (!this.groups.some((f) => f.field === "DetailLedger1Title") && this.detailLedgerLevel >= 1)
                this.groups.push({ field: "DetailLedger1Title" });
              x.listVisible = this.detailLedgerLevel >= 1;
              if (x.name.includes("DetailLedgerId")) x.listVisible = false;
            }
            if (x.name.includes("DetailLedger2")) {
              if (!this.groups.some((f) => f.field === "DetailLedger2Title") && this.detailLedgerLevel >= 2)
                this.groups.push({ field: "DetailLedger2Title" });
              x.listVisible = this.detailLedgerLevel >= 2;
              if (x.name.includes("DetailLedger2Id")) x.listVisible = false;
            }
            if (x.name.includes("DetailLedger3")) {
              if (!this.groups.some((f) => f.field === "DetailLedger3Title") && this.detailLedgerLevel >= 3)
                this.groups.push({ field: "DetailLedger3Title" });
              x.listVisible = this.detailLedgerLevel >= 3;
              if (x.name.includes("DetailLedger3Id")) x.listVisible = false;
            }
            if (x.name.includes("DetailLedger4")) {
              if (!this.groups.some((f) => f.field === "DetailLedger4Title") && this.detailLedgerLevel >= 4)
                this.groups.push({ field: "DetailLedger4Title" });
              x.listVisible = this.detailLedgerLevel >= 4;
              if (x.name.includes("DetailLedger4Id")) x.listVisible = false;
            }
            if (x.name.includes("DetailLedger5")) {
              if (!this.groups.some((f) => f.field === "DetailLedger5Title") && this.detailLedgerLevel >= 5)
                this.groups.push({ field: "DetailLedger5Title" });
              x.listVisible = this.detailLedgerLevel >= 5;
              if (x.name.includes("DetailLedger5Id")) x.listVisible = false;
            }
            if (x.name.includes("DetailLedger6")) {
              if (!this.groups.some((f) => f.field === "DetailLedger6Title") && this.detailLedgerLevel >= 6)
                this.groups.push({ field: "DetailLedger6Title" });
              x.listVisible = this.detailLedgerLevel >= 6;
              if (x.name.includes("DetailLedger6Id")) x.listVisible = false;
            }
            if (x.name.includes("DetailLedger7")) {
              if (!this.groups.some((f) => f.field === "DetailLedger7Title") && this.detailLedgerLevel >= 7)
                this.groups.push({ field: "DetailLedger7Title" });
              x.listVisible = this.detailLedgerLevel >= 7;
              if (x.name.includes("DetailLedger7Id")) x.listVisible = false;
            }
          });
        }
      });
  }
}
